import intl from 'react-intl-universal';
import { useState, useEffect } from 'react';
import { Checkbox, Radio, Tag } from 'antd';
import Exhibition from '../Exhibition';
import { isEmpty, isObject } from 'lodash';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import style from './index.less';

// type ValueType = string | number | boolean;

export type checkType = 'checkbox' | 'radio' | 'none' | string;

interface Props {
    checkType?: checkType; // 默认 ‘checkbox’ none表示不展示选择
    disabled?: boolean; // 整体禁用， 如禁用某一个，需要在data里面传入disabled字段
    data: any[];
    onChange?: (value: valueType) => void;
    commodityColumns: any[];
    col?: number;
}

type valueType = { [key: string]: boolean | valueType };

const defaultGroupCommodityTitle = [
    {
        label: intl.get('商品名称'),
        key: 'name',
        isHover: true,
    },
    {
        label: intl.get('商品类型'),
        key: 'category_name',
    },
];

const Commoditys: React.FC<Props> = (props) => {
    const {
        data: originData = [],
        checkType = 'checkbox',
        disabled = false,
        onChange,
        commodityColumns,
        col = 3,
    } = props;
    const [data, setData] = useState(originData);
    const [value, setValue] = useState<valueType>({});
    const [formValue, setFormValue] = useState<(string | number)[]>([]);
    useEffect(() => {
        initData();
    }, [originData]);

    const initData = () => {
        setData(
            originData.map((item) => ({
                ...item,
                isExpand: false,
            })),
        );
    };

    const handleChangeGroupState = (index: number) => {
        const item = data[index];
        data.splice(index, 1, {
            ...item,
            isExpand: !item.isExpand,
        });
        setData([...data]);
    };

    const renderItem = (item: any): React.ReactNode | string => {
        return (
            <div
                key={item.id}
                className={style.commodityItem}
            >
                <Exhibition
                    className={style.commodityInfo}
                    data={item}
                    columns={commodityColumns}
                    config={{ col: col }}
                ></Exhibition>
                <div className={style.tagContainer}>
                    {item.hidden && (
                        <Tag
                            color="orange"
                            className={style.tag}
                        >
                            {intl.get('隐藏')}
                        </Tag>
                    )}
                    {item.isGiftTag && (
                        <Tag
                            color="orange"
                            className={style.tag}
                        >
                            {intl.get('赠品')}
                        </Tag>
                    )}
                </div>

                {checkType === 'checkbox' && (
                    <Checkbox
                        className="commodity_checkbox"
                        disabled={item.disabled}
                        onChange={(e) => {
                            // if (e.target.checked) {
                            //     if (!item?.is_gift && item?.hasGift) {
                            //         message.warning(
                            //             '买赠商品退款时需要一起售后，请重新选择商品后再发起售后！',
                            //         );
                            //     }
                            // }
                            onItemValueChange(
                                item.id,
                                e.target.checked,
                                item.parentGood?.id,
                            );
                        }}
                        value={item.id}
                    />
                )}
                {checkType === 'radio' && (
                    <Radio
                        disabled={item.disabled}
                        value={item.id}
                        onChange={(e) => {
                            onItemValueChange(
                                item.id,
                                e.target.value,
                                item.parentGood?.id,
                            );
                        }}
                    />
                )}
            </div>
        );
    };

    const renderGroup = (
        group: any,
        index: number,
    ): React.ReactNode | string => {
        const childrens = group.sub_goods_infos || group.children || [];
        return (
            <div
                key={index}
                className={style.commodityGroupContainer}
            >
                <div
                    className={style.commodityGroupTitle}
                    onClick={() => {
                        handleChangeGroupState(index);
                    }}
                >
                    <Exhibition
                        className={style.commodityGroupTitleInfo}
                        data={group}
                        columns={defaultGroupCommodityTitle}
                        config={{ col: col }}
                    />

                    {group.isExpand ? <UpOutlined /> : <DownOutlined />}
                </div>
                {group.isExpand && (
                    <div className={style.commodityContent}>
                        {childrens.map((item: any) => renderItem(item))}
                    </div>
                )}
            </div>
        );
    };

    const onItemValueChange = (
        key: string | number,
        isCheck: boolean,
        parent_id: string,
    ) => {
        if (!parent_id) {
            value[key] = isCheck;
        } else {
            value[parent_id] = isObject(value[parent_id])
                ? value[parent_id]
                : {};
            // @ts-ignore
            value[parent_id][key] = isCheck;
        }

        let isHasGift = data.some((item: any) => item?.is_gift);
        let filterArr: any = [];
        if (parent_id) {
            let parentArr = data.filter((item: any) => item?.id === parent_id);
            filterArr = parentArr[0]?.children.filter(
                (item: any) => item?.id === key,
            );
        } else {
            filterArr = data.filter((item: any) => item?.id === key);
        }

        let giftArr = data.filter((item: any) => item?.is_gift);
        let valueObj: any = {};
        if (isCheck) {
            if (isHasGift && filterArr.length && !filterArr[0]?.is_gift) {
                let arr: any[] = [];
                giftArr?.forEach((item: any) => {
                    arr.push(item?.id);
                    valueObj[item?.id] = true;
                });

                setFormValue([...formValue, key, ...arr]);
            } else {
                setFormValue([...formValue, key]);
            }
        } else {
            formValue.splice(formValue.indexOf(key), 1);
            setFormValue([...formValue]);
        }

        setValue({ ...value, ...valueObj });
        onChange && onChange({ ...value, ...valueObj });
    };

    // const onValueChange = (e: any) => {
    //     if (e.target) {
    //         onChange && onChange(e.target.value);
    //         return;
    //     }
    //     onChange && onChange(e);
    // };
    // console.log(formValue, '----formValue---');
    return !isEmpty(data) ? (
        <div>
            {checkType === 'checkbox' && (
                <Checkbox.Group
                    disabled={disabled}
                    className={style.commodityCheckBox}
                    value={formValue}
                    // onChange={onValueChange}
                >
                    {data.map((item, index) =>
                        item.children
                            ? renderGroup(item, index)
                            : renderItem(item),
                    )}
                </Checkbox.Group>
            )}
            {checkType === 'radio' && (
                <Radio.Group
                    disabled={disabled}
                    className={style.commodityCheckBox}
                    // onChange={onValueChange}
                >
                    {data.map((item, index) =>
                        item.children
                            ? renderGroup(item, index)
                            : renderItem(item),
                    )}
                </Radio.Group>
            )}
            {(checkType === 'none' || !checkType) &&
                data.map((item, index) =>
                    item.children ? renderGroup(item, index) : renderItem(item),
                )}
        </div>
    ) : (
        <div>{intl.get('暂无商品')}</div>
    );
};

export default Commoditys;
